// Configuración de Firebase para el Admin Dashboard
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// `npm run dev:emulador` prueba el panel contra los emuladores locales
// (firebase emulators:start --only auth,firestore) con las reglas del repo.
const useEmulators = import.meta.env.VITE_USE_EMULATORS === "true";

if (useEmulators) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
}

/**
 * Auth de una segunda instancia de la app. Crear una cuenta con la instancia
 * principal inicia sesión con ella y expulsaría al administrador del panel.
 */
let secondary;
export function secondaryAuth() {
  if (!secondary) {
    secondary = getAuth(initializeApp(firebaseConfig, "secondary"));
    if (useEmulators) connectAuthEmulator(secondary, "http://127.0.0.1:9099", { disableWarnings: true });
  }
  return secondary;
}
